<script setup lang="ts">
import type { UIAlertProps, UINotification } from '../../types'
import { useNotifications, useXmppListener } from '#imports'

const { notifications, add, remove } = useNotifications()
defineSlots<{
    [key: string]: (props: { notification: UINotification, remove: typeof remove }) => any
}>()

useXmppListener<{
    message: string
    type: NonNullable<UIAlertProps['type']>
    customerId: string
    uniqueId: string
    altText: string
}>({
    kind: 'message',
    type: undefined,
    xmlns: 'cego:UserNotification'
}, ({ type, message }) => {
    add({
        type: 'cego:UserNotification',
        alert: {
            type,
            message,
            closeable: true,
        },
        clearOnPageChange: true
    })
})
</script>

<template>
    <div class="notifications">
        <template v-for="notification in notifications" :key="notification.id">
            <slot :name="notification.type" v-bind="{ notification, remove }">
                <UIAlert
                    v-if="notification.alert"
                    class="notifications__alert"
                    v-bind="notification.alert"
                    @closed="remove(notification.id)"
                />
            </slot>
        </template>
    </div>
</template>

<style scoped lang="scss">
.notifications {
    :deep(.notifications__alert) {
        font-size: 14px;
        margin-bottom: unset;
        z-index: z(folded-hero);
    }
}
</style>
